// @flow
import React, { useEffect, useState, useCallback, useMemo, useRef } from 'react'
import * as DmsCommon from './../supports/dms-common';
import * as DmsService from './../supports/dms-service';
import { GlobalEvent, GlobalState } from './GlobalContext'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DocDListGridEdit from './DocDListGridEdit';
import SelMemberDialog from './SelMemberDialog';
import MsgDialog from './MsgDialog';
import Backdrop from '@mui/material/Backdrop';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import DialogActions from '@mui/material/DialogActions';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PersonAddAlt1Icon from '@mui/icons-material/PersonAddAlt1';
import PersonRemoveIcon from '@mui/icons-material/PersonRemove';
import CircularProgress from '@mui/material/CircularProgress';


import PropTypes from 'prop-types';
import CssBaseline from '@mui/material/CssBaseline';

import ConfirmDialog from './ConfirmDialog';

export default function SendNotificationForMoveDocDialog(props) {

  const { sysID, targetFolderID, open, onClose, onSend } = props;

  // Get Global state and dispatcher
  const [gState, gStateDispatch] = React.useContext(GlobalState);

  const [gEvent, gEventDispatch] = React.useContext(GlobalEvent);

  const [showLoading, setShowLoading] = useState(false);
  const [showError, setShowError] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [distData, setDistData] = useState([]);

  const [anchorElAdd, setAnchorElAdd] = useState(null);
  const openAddDialog = Boolean(anchorElAdd);
  const handleAddClick = (event) => {
    setAnchorElAdd(event.currentTarget);
  };
  const handleCloseAddMenu = () => {
    setAnchorElAdd(null);
  };

  const [openAddDistUserDialog, setOpenAddDistUserDialog] = useState(false);
  const [allFolderUsers, setAllFolderUsers] = useState([]);
  // const [members, setMembers] = useState([]);
  const [groups, setGroups] = useState([]);

  const onCatchPromiseError = (e) => {
    gEventDispatch({
      showErr: true,
      err: e,
    });

  }

  useEffect(() => {

    if (open === true) {

      const xFunc = async () => {
        setDistData([]);
        setSelectedDistRecs([]);

        try {
          const [vAllFolderUsers, , vGroups] =
            await DmsService.getFolderAccessibleUsersPromise(gState.sessionID, sysID, targetFolderID);
          setAllFolderUsers(vAllFolderUsers);
          // setMembers(vMembers);
          setGroups(vGroups);

        } catch (e) {
          onCatchPromiseError(e);
        }


      }
      xFunc();


    }

  }, [open])



  const handleAddDistUserClick = async () => {
    setAnchorElAdd(null);

    setOpenAddDistUserDialog(true);

  };

  const handleSelectAddDistUsers = (aUsers, aGroups) => {
    // console.log("aUsers", aUsers);
    // console.log("aGroups", aGroups);

    setOpenAddDistUserDialog(false);

    let vData = distData.map(item => {
      return item
    });


    aUsers.forEach(addUser => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": addUser.Department,
          "ToUserID": addUser.UserID,
          "ToUserName": addUser.FullName,
          "IsUser": true,
        }

        vData.push(vNewItem);

      }
    });

    aGroups.forEach(addGroup => {
      const vFound = vData.find(f => f.ToUserID.toLowerCase() === addGroup.GroupID.toLowerCase());
      if (!vFound) {
        // console.log("addUser", addUser);
        const vNewItem = {
          "ActionReq": 0,
          "DeptName": "",
          "ToUserID": addGroup.GroupID,
          // "ToUserName": addGroup.GroupNameDisplay,
          "ToUserName": addGroup.Name,
          "IsUser": false,
        }

        vData.push(vNewItem);

      }
    });

    // console.log("vData", vData);
    setDistData(vData);
    setSelectedDistRecs([]);

  }




  const handleAddAllAuthDistUsers = async () => {
    setAnchorElAdd(null);

    setShowLoading(true);

    try {

      let vData = distData.map(item => {
        return item
      });

      let vHasUpdate = false;


      allFolderUsers.forEach(addUser => {
        const vFound = vData.find(f => f.ToUserID.toLowerCase() === addUser.UserID.toLowerCase());
        if (!vFound) {
          // console.log("addUser", addUser);
          const vNewItem = {
            "ActionReq": 0,
            "DeptName": addUser.Department,
            "ToUserID": addUser.UserID,
            "ToUserName": addUser.FullName,
            "IsUser": true,
          }

          vData.push(vNewItem);

          vHasUpdate = true;
        }
      });

      if (vHasUpdate === true) {
        // console.log("vData", vData);
        setDistData(vData);
        setSelectedDistRecs([]);
      }

      setShowLoading(false);
    } catch (e) {
      setShowLoading(false);
      setErrMsg(e.errMsg || e.message);
      setShowError(true);
    };

  };

  const handleActionChange = (aRecord, aNewValue) => {
    // console.log("handleActionChange", aCurIdx, aNewValue);

    const vNewGridData = distData.map((d, idx) => {
      if (d.ToUserID == aRecord.ToUserID) {
        return {
          ...d,
          "ActionReq": aNewValue,
        }
      } else {
        return d;
      }
    });

    setDistData(vNewGridData);
  };

  const handleRemoveDist = () => {
    // console.log("handleRemoveDist selectedDistRecs", selectedDistRecs);

    const vData = distData.filter(d => !selectedDistRecs.some(r => r.ToUserID === d.ToUserID));
    setDistData(vData);
    setSelectedDistRecs([]);

  }




  const [selectedDistRecs, setSelectedDistRecs] = useState([]);

  const handleDistSelectionChange = (aRecords) => {

    setSelectedDistRecs(aRecords);

  }





  const handleCloseClick = () => {

    onClose && onClose();
  }



  const handleSend = () => {
    const vDistList = distData.map(d => {
      return {
        "UserID": d.ToUserID,
        "ActionReq": d.ActionReq,
      }
    })
    onSend && onSend(vDistList);
  }

  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);


  return (
    <React.Fragment>
      <CssBaseline />
      <Dialog
        // fullScreen
        maxWidth="md"
        fullWidth={true}
        open={open}
        // onClose={handleCloseClick}
        aria-describedby="upload-single-dialog-description"


      >
        <Backdrop
          sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
          open={showLoading}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
        <MsgDialog
          open={showError}
          title="Error"
          msgText={errMsg}
          onClose={() => setShowError(false)}
        />


        <SelMemberDialog
          open={openAddDistUserDialog}
          onClose={() => { setOpenAddDistUserDialog(false) }}
          members={allFolderUsers}
          groups={groups}
          onSelect={handleSelectAddDistUsers}
        />


        <DialogTitle>Notification Email</DialogTitle>
        <DialogContent>

          <ConfirmDialog
            open={openConfirmDialog}
            text={`Do you confirm to send email notification to ${distData.length} user(s)/group(s)?`}
            confirmBtnCaption='Yes'
            cancelBtnCaption="No"
            onCancelClick={() => setOpenConfirmDialog(false)}
            onConfirmClick={() => {
              setOpenConfirmDialog(false);
              handleSend();
            }}
          />

          <Box sx={{ display: 'flex', flexDirection: 'column', height: "70vh", mt: 1 }}  >
            <Box sx={{ py: 0, px: 1 }}  >
              <Button
                id="add-button"
                aria-controls="add-menu"
                aria-haspopup="true"
                aria-expanded={openAddDialog ? 'true' : undefined}
                startIcon={<PersonAddAlt1Icon />}
                onClick={handleAddClick}
              >
                Add
              </Button>
              <Menu
                id="add-menu"
                anchorEl={anchorElAdd}
                open={openAddDialog}
                onClose={handleCloseAddMenu}
                MenuListProps={{
                  'aria-labelledby': 'add-button',
                }}
              >
                <MenuItem onClick={handleAddDistUserClick}>Users</MenuItem>
                <MenuItem onClick={handleAddAllAuthDistUsers}>All Authorized Users</MenuItem>
              </Menu>

              <Button startIcon={<PersonRemoveIcon />} disabled={selectedDistRecs.length == 0} onClick={handleRemoveDist}>
                Remove
              </Button>


            </Box>

            <Box sx={{ display: 'flex', flexDirection: 'column', height: "60vh" }} >
              <DocDListGridEdit
                gridData={distData}
                onActionChange={handleActionChange}
                onSelectChange={handleDistSelectionChange}
              />

            </Box>


          </Box>

        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseClick}>Cancel</Button>
          <Button variant="contained" onClick={() => setOpenConfirmDialog(true)} disabled={distData.length == 0} >Send</Button>
        </DialogActions>
      </Dialog>

    </React.Fragment >

  );
}

SendNotificationForMoveDocDialog.propTypes = {
  sysID: PropTypes.string,
  targetFolderID: PropTypes.number,
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onSend: PropTypes.func,
};


